import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import DirectorListLayer from "../components/DirectorListLayer";
 
 
const HighlightListPage = () => {
  return (
    <>

 
        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Directors  </h5><Breadcrumb title="Directors" /></div>
 
        <DirectorListLayer />
 
 
 
    </>
  );
};
 
export default HighlightListPage;
 
 